<template>
  <div class="editor-header-logo-container">
    <span>
      <div
        v-aha-emit-action
        name="editor-back-button"
        class="back-presentation cursor-pointer"
        v-tooltip="$i18nPresenter.t('Back')"
        @click="backAction"
      >
        <aha-icon
          name="arrow-tail"
          viewBox="0 0 18 19"
          width="21"
          height="22"
        />
      </div>
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('presentationEditor', [
      'backAction',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.editor-header-logo-container {
  @apply pl-3.5 pr-2 2xs:pr-5 flex items-center h-full;
  padding-right: 0.5rem;
}

.back-presentation {
  @apply rounded-full flex items-center justify-center w-10 h-10 hover:bg-base-40;
  backdrop-filter: blur(44px);
}
</style>
